import axios from 'axios';
import config from '../config/constants';

export default class RecsiteAPI {

	static cookieSession = '3fce8a0c2ad9b561ba36c8d60ab822c3';
	
	static protocol = 'http';
	
	/**
	 * get protocol
	 * @returns {* | string}
	 */
	static getProtocol = () => {
		if (config.PROTOCOL) {
			return config.PROTOCOL;
		}
		if (window.location.protocol === 'https:') {
			RecsiteAPI.protocol = 'https';
			return 'https';
		}
		RecsiteAPI.protocol = 'http';
		return 'http';
	};
	
	/**
	 * Get host and set default if local
	 * @returns {* | string}
	 */
	static getHost = () => {
		if (config.HOST_NAME) {
			return config.HOST_NAME;
		}
		if (window.location.hostname !== 'localhost') {
			return window.location.host
		}
		return 'recsite.local';
	};
	
	/**
	 * Get base path
	 * @returns {string}
	 */
	static getBasePath = () => {
		return `${RecsiteAPI.getProtocol()}://${RecsiteAPI.getHost()}/api/api`;
	};
	
	/**
	 *
	 * @param filters
	 * @returns {string}
	 */
	static getVacancyQueryString = (filters) => {
		
		let string = '?';
		string += (filters.limit && filters.limit !== '') ? `limit=${filters.limit}&` : '';
		string += (filters.keyword && filters.keyword !== '') ? `keyword=${filters.keyword}&` : '';
		string += (filters.sortBy && filters.sortBy !== '') ? `sortBy=${filters.sortBy}&` : '';
		string += (filters.industryId && parseInt(filters.industryId, 0) !== 0) ? `industryId=${filters.industryId}&` : '';
		string += (filters.subIndustryId && parseInt(filters.subIndustryId, 0) !== 0) ? `subIndustryId=${filters.subIndustryId}&` : '';
		string += (filters.locationId && parseInt(filters.locationId, 0) !== 0) ? `locationId=${filters.locationId}&` : '';
		string += (filters.salaryTypeId && parseInt(filters.salaryTypeId, 0) !== 0) ? `salaryTypeId=${filters.salaryTypeId}&` : '';
		string += (filters.postedAtId && parseInt(filters.postedAtId, 0) !== 0) ? `postedAt=${filters.postedAtId}&` : '';
		return string;
	};
	
	/**
	 *
	 * @returns {Promise<any>}
	 *
	 *
	 * filters: {
			keyword: '',
			sortBy: 'date','location','position'
			industryId: 0,
			subIndustryId: 0,
			locationId: 0,
			salaryTypeId: 0,
			postedAtId: 0
		},
	 */
	static getVacancies = (filters = null) => {
		
		let queryString = '';
		if (filters) {
			queryString = RecsiteAPI.getVacancyQueryString(filters);
		}
		
		return new Promise((resolve, reject) => {
			axios.get(`${RecsiteAPI.getBasePath()}/v2/public/vacancies${queryString}`, {
				headers: {
					'Session': RecsiteAPI.cookieSession,
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				resolve(res.data);
			}).catch(error => {
				console.log(error.response, 'Error from API');
				reject(error.response);
			});
		})
	};
	
	/**
	 *
	 * @param id
	 * @returns {Promise<any>}
	 */
	static getVacancyById = (id) => {
		return new Promise((resolve, reject) => {
			axios.get(`${RecsiteAPI.getBasePath()}/v2/public/vacancies/${id}`, {
				headers: {
					'Session': RecsiteAPI.cookieSession,
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				
				console.log(res.data, 'res.data');
				let response = {};
				if (res.data && res.data.data) {
					if (res.data.data.attributes) {
						response = res.data.data.attributes;
					}
				}
				resolve(response);
			}).catch(error => {
				console.log(error.response, 'Error from API');
				reject(error.response);
			});
		})
	};
	
	static getIndustries = () => {
		return new Promise((resolve, reject) => {
			axios.get(`${RecsiteAPI.getBasePath()}/resource/industries`, {
				headers: {
					'Session': RecsiteAPI.cookieSession,
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				let response = res.data;
				resolve(response);
			}).catch(error => {
				console.log(error.response, 'Error from API');
				reject(error.response);
			});
		})
	};
	
	static getLocations = () => {
		return new Promise((resolve, reject) => {
			axios.get(`${RecsiteAPI.getBasePath()}/resource/locations`, {
				headers: {
					'Session': RecsiteAPI.cookieSession,
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				let response = res.data;
				resolve(response);
			}).catch(error => {
				console.log(error.response, 'Error from API');
				reject(error.response);
			});
		})
	};
	
	static getSalaryTypes = () => {
		return new Promise((resolve, reject) => {
			axios.get(`${RecsiteAPI.getBasePath()}/resource/salary`, {
				headers: {
					'Session': RecsiteAPI.cookieSession,
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				let response = res.data;
				resolve(response);
			}).catch(error => {
				console.log(error.response, 'Error from API');
				reject(error.response);
			});
		})
	};
	
	/**
	 * user login
	 */
	static userLogin = () => {
		const redirect = `${config.PROTOCOL}://${config.DOMAIN}/login`;
		window.location.replace(redirect);
	}
}


// WEBPACK FOOTER //
// ./src/service/RecsiteAPI.js